import React from 'react';
import Page from "../component/Page/Page";
import ProfileForm from "../component/User/ProfileForm";

class ProfileFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    return (
        <Page title="Meus dados" noBreadcrumbs>
          <ProfileForm match={match} history={history}/>
        </Page>
    );
  }
}

export default ProfileFormPage;



// WEBPACK FOOTER //
// ./src/profile/ProfileFormPage.js